module.exports = __webpack_public_path__ + "img/Salud.3fc3a1f1.png";